import { render } from "./NoConnectedNumbers.vue?vue&type=template&id=6f26eaf6&scoped=true"
const script = {}

import "./NoConnectedNumbers.vue?vue&type=style&index=0&id=6f26eaf6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f26eaf6"]])

export default __exports__